import { parseISO, parse, format, formatISO } from 'date-fns';

export const dateIso2Us = (isoIn) => {
    return format(parseISO(isoIn), 'P');
}

export const dateUs2Iso = (dateIn) => {
    return formatISO(parse(dateIn, 'MM/dd/yyyy', new Date()) , {representation: 'date'})
}